var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"UIElement"}},[_c('qrcode-stream',{on:{"decode":_vm.onDecode,"init":_vm.onInit}}),_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }